import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { CssBaseline } from '@material-ui/core';
import FullpageSpinner from '../FullpageSpinner/FullpageSpinner';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    minHeight: '100vh'
  },
  appContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  }
}));


const FullAppSpinner = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <div className={classes.appContent}>
        <FullpageSpinner />
      </div>
    </div>
  );
};

export default FullAppSpinner;